export default {
  whatsappAuth: {},
};
